import { findTodoLists } from '@erikdakoda/todo/ai-tools/findTodoLists';
import { registerAiTool } from '@erikdakoda/ai-tool/aiToolRegistry';

registerAiTool(findTodoLists);
